export default __webpack_public_path__ + "static/media/Pamungkas - Kenangan Manis.28b3f7de.jpg";